import { action } from 'typesafe-actions';
import { NotificationsTypes } from './types';

export const loadNotifications = (inscricoesEstaduais: number[]) =>
  action(NotificationsTypes.LOAD_NOTIFICATIONS_REQUEST, {
    inscricoesEstaduais,
  });

export const loadNotificationsSuccess = (notification: number) =>
  action(NotificationsTypes.LOAD_NOTIFICATIONS_SUCCESS, { notification });

export const loadNotificationsFailure = () =>
  action(NotificationsTypes.LOAD_NOTIFICATIONS_FAILURE, {});

export const loadMessageReadRequest = (protocolo: number) =>
  action(NotificationsTypes.LOAD_MESSAGE_READ, { protocolo });
